"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

/**
 * Checks if page has auto height
 *
 * @param {Object} page
 * @returns {Boolean} is page height auto
 */
var isHeightAuto = R.pathSatisfies(R.isNil, ['box', 'height']);
var _default = isHeightAuto;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-pdf/layout/lib/page/isHeightAuto.js
// module id = ./node_modules/@react-pdf/layout/lib/page/isHeightAuto.js
// module chunks = 1